module.exports = __webpack_public_path__ + "img/orange_hover.9683bf06.png";